import { ISalary, Salary } from '../salary';
import { ILanguage, Language } from '../language';
import {
  AppliedJobPosition,
  IAppliedJobPosition
} from './applied-job-position';

export interface IJobRequirements {
  status?: number;
  statusName?: string;
  career_objective?: string;
  agree_mail_receive?: boolean;
  additional?: IAppliedJobPosition[];
  current?: IAppliedJobPosition;
  employment_type?: string;
  languages?: ILanguage[];
  salary?: ISalary;
}

export class JobRequirements {
  status: number;
  statusName: string;
  career_objective?: string;
  agree_mail_receive: boolean;
  additional: AppliedJobPosition[];
  current: AppliedJobPosition;
  employment_type: string;
  languages: Language[];
  salary: Salary;

  constructor(data: IJobRequirements = {}, roleType?: any) {
    this.status = data.status >= 0 ? data.status : 0;
    this.statusName = this.getStatusName(this.status);
    this.career_objective = data.career_objective || '';
    this.agree_mail_receive = data.agree_mail_receive || true;
    this.additional = (data.additional || []).map((item) => new AppliedJobPosition(item));
    this.current = new AppliedJobPosition(data.current);
    this.employment_type = data.employment_type || '';
    if (roleType === '22') {
      this.languages = data.languages.length
        ? data.languages.map((item) => new Language(item))
        : [new Language({ title: 'English', name: 'English', level: '' })];
    } else {
      this.languages = data.languages.length
        ? data.languages.map((item) => new Language(item))
        : [new Language()];
    }
    this.salary = new Salary(data.salary);
  }

  private getStatusName(status: number) {
    switch (status) {
      case 0:
        return 'Actively looking';
      case 1:
        return 'Passively looking';
      case 2:
        return 'Not available';
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/job-requirements.ts